<template>
  <div class="min-h-screen flex flex-col">
    <LoaderStatus />
    <suspense>
      <router-view />
    </suspense>
    <AppConfirmDialog />
    <AppDynamicDialog />
  </div>
</template>

<script setup>
  import LoaderStatus from '@/components/layout/LoaderStatus.vue';
  import AppConfirmDialog from '@/components/AppConfirmDialog.vue';
  import AppDynamicDialog from '@/components/AppDynamicDialog.vue';
</script>
